import { FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { CHART_COLORS } from "../common/constants";
import { SpendingDataPoint } from "../common/types";

type PurchaseTypeChartProps = {
  data: SpendingDataPoint[];
};

export const PurchaseTypeChart: FC<PurchaseTypeChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="avatar_purchases"
          name="Avatars"
          fill={CHART_COLORS.avatarPurchases}
        />
        <Bar
          dataKey="badge_purchases"
          name="Badges"
          fill={CHART_COLORS.badgePurchases}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
